module.exports = __webpack_public_path__ + "static/img/wzmacniacz.bcd2727.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/wzmacniacz.svg
// module id = DYdb
// module chunks = 1